export default __webpack_public_path__ + "static/media/photo--sm--blitz-3.be34ceea.jpg";